
/**
 *  putQuestions.js
 *  提问模块的api
 */

import request from "./api";

/* 老师查询提问列表 */
export const teacherFindAsk = (params) => request('/api-study/ask/teacherFindAsk', params, { method: 'post'});

/* 学生查询提问列表 */
export const studentFindAsk = (params) => request('/api-study/ask/studentFindAsk', params, { method: 'post'});

/* 学生提问 */
export const addAsk = (params) => request('/api-study/ask/addAsk', params, { method: 'post'});

/* 修改提问 */
export const updateAsk = (params) => request('/api-study/ask/updateAsk', params, { method: 'post'});

/* 删除提问 */
export const deleteAsk = (id) => request('/api-study/ask/deleteAsk/' + id, {}, { method: 'DELETE'});

/* 保存简要记录 */
export const saveAskRecord = (params) => request('/api-study/ask/saveAskRecord', params, { method: 'post'});

/* 查询简要记录 */
export const findAskRecordById = (id) => request('/api-study/ask/findAskRecordById?id=' + id );

/* 删除简要记录 */
export const deleteAskRecord = (id) => request('/api-study/ask/deleteAskRecord/' + id, {}, { method: 'DELETE'});



// WEBPACK FOOTER //
// ./src/api/putQuestions.js